import React, { useState } from 'react'
import { ellips, verMessage } from '../../../assets'
import ReactInputVerificationCode from 'react-input-verification-code'
import './style.css'
import { Button } from '../../../components/Generic'

const Num = () => {
  const [inputValue, setInputValue] = useState('');

  console.log("Code:", inputValue)
  return (
    <>
            <img className="absolute top-[40%] left-[15%] z-0 md:left-[42%]" src={ellips} alt="" />
    <div className='flex flex-col mt-[100px] justify-center items-center z-10'>
      <img className='' src={verMessage} alt="" />
      <div className='text-gray-darkGray font-sans text-[20px] mt-[24px]'>Enter code</div>
      <div className='text-gray-lightGray font-[Poppins] mt-[25px] text-[15px] font-medium '>Shu raqamga yuborilgan sms kodni kiriting</div>
      <div className='font-[Poppins] text-blue-chatBlue text-[15px] font-medium'>+998934025776</div>
      <div className='custom-styles mt-[102px] flex justify-center'>
      <ReactInputVerificationCode 
      placeholder=''
      length={6}
      onChange={(value) => setInputValue(value)}
      />
      </div>
      <div className='flex justify-between w-full mt-[55px] mb-[97px]'>
        <div className='text-[17px] font-sans'>Raqamni o’zgartirish</div>
        <div className='text-blue-chatBlue font-sans text-[17px]'>Qayta jo’natish</div>
      </div>
      <div className='w-[288px] md:w-full flex justify-center mb-[100px]'>
      <Button link={'/settingprofdata'} style={`w-[388px]`} value={'Next'}/>
      </div>
    </div>
    </>
  )
}

export default Num